var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgJszf = function SvgJszf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 4c6.279 0 11.988 1.356 16.145 3.573C50.282 9.78 53 12.912 53 16.5c0 .405-.037.804-.105 1.197A.495.495 0 0 1 53 18v7.5c0 .405-.037.804-.105 1.197A.495.495 0 0 1 53 27v7.5c0 .405-.037.804-.105 1.197A.495.495 0 0 1 53 36v7.5c0 3.588-2.719 6.72-6.855 8.927C41.989 54.644 36.28 56 30 56s-11.988-1.356-16.145-3.573C9.719 50.22 7 47.088 7 43.5V36c0-.114.04-.218.104-.303A7.063 7.063 0 0 1 7 34.5V27c0-.114.04-.218.104-.303A7.063 7.063 0 0 1 7 25.5V18c0-.114.04-.218.104-.303A7.063 7.063 0 0 1 7 16.5c0-3.588 2.719-6.72 6.854-8.927C18.012 5.356 23.721 4 30 4Zm20.3 36.408c-1.11 1.131-2.521 2.148-4.154 3.019C41.987 45.644 36.278 47 30 47s-11.988-1.356-16.145-3.573c-1.634-.871-3.045-1.888-4.156-3.019 1.08 1.345 2.646 2.58 4.626 3.636C18.311 46.17 23.852 47.5 30 47.5c6.148 0 11.689-1.33 15.675-3.456 1.98-1.056 3.547-2.29 4.626-3.636Zm0-9c-1.11 1.131-2.521 2.148-4.154 3.019C41.987 36.644 36.278 38 30 38s-11.988-1.356-16.145-3.573c-1.634-.871-3.045-1.888-4.156-3.019 1.08 1.345 2.646 2.58 4.626 3.636C18.311 37.17 23.852 38.5 30 38.5c6.148 0 11.689-1.33 15.675-3.456 1.98-1.056 3.547-2.29 4.626-3.636Zm0-9c-1.11 1.131-2.521 2.148-4.154 3.019C41.987 27.644 36.278 29 30 29s-11.988-1.356-16.145-3.573c-1.634-.871-3.045-1.888-4.156-3.019 1.08 1.345 2.646 2.58 4.626 3.636C18.311 28.17 23.852 29.5 30 29.5c6.148 0 11.689-1.33 15.675-3.456 1.98-1.056 3.547-2.29 4.626-3.636ZM24.6 8.2a1 1 0 1 0-1.2 1.6l2.4 1.8a.501.501 0 0 1-.3.9h-3a1 1 0 0 0 0 2h6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H21a1 1 0 0 0 0 2h7.5a.5.5 0 0 1 .5.5v3a1 1 0 1 0 2 0v-3a.5.5 0 0 1 .5-.5H39a1 1 0 1 0 0-2h-7.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h6a1 1 0 1 0 0-2h-3a.5.5 0 0 1-.3-.9l2.4-1.8a1 1 0 1 0-1.2-1.6l-5.1 3.825a.5.5 0 0 1-.6 0L24.6 8.2Z",
    fill: "url(#jszf_svg__a)",
    stroke: "url(#jszf_svg__b)",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jszf_svg__a",
    x1: 30,
    y1: 4.5,
    x2: 30,
    y2: 55.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jszf_svg__b",
    x1: 30,
    y1: 4.5,
    x2: 30,
    y2: 55.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))));
};

export default SvgJszf;